module.exports = __webpack_public_path__ + "images/backgrounds/red-sweater.145d20cd1fdc81c2e282.png";